function isResourceRef(value) {
  return (value == null ? void 0 : value.$ref) != null;
}
async function resolveResourceRef(item) {
  if (isResourceRef(item)) {
    return await fetch(item.$ref).then(async (res) => await res.json());
  } else {
    return item;
  }
}
export {
  isResourceRef,
  resolveResourceRef
};
